module.exports = __webpack_public_path__ + "img/SKWINKELNetActieSuggesties5FA7C4.f797c2b6.png";